// extracted by mini-css-extract-plugin
export default {"footerBtns":"cancelBooking_footerBtns__24oXw","mb16":"cancelBooking_mb16__lSC9q","disclaimerSection":"cancelBooking_disclaimerSection__-86t+","modal":"cancelBooking_modal__bKzPU"};